<template>
  <page>
    <div>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
                  <v-expansion-panels v-model="expanel1" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                <message :messages="messages"></message>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="form.oldGstRate"
                          :label="labels.oldGstRate"
                          :error-messages="errors.collect('form.oldGstRate')"
                          data-vv-name="form.oldGstRate"
                          :data-vv-as="labels.oldGstRate"
                          v-validate="'required'"
                          readonly
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="doHelpList('oldGstRate')">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="form.newGstRate"
                          :label="labels.newGstRate"
                          :error-messages="errors.collect('form.newGstRate')"
                          data-vv-name="form.newGstRate"
                          :data-vv-as="labels.newGstRate"
                          v-validate="'required'"
                          readonly
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="doHelpList('newGstRate')">mdi-magnify</v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md4>
                        <cal-picker
                          v-model="form.effDate"
                          :label="labels.effDate"
                          :data-vv-as="labels.effDate"
                          data-vv-name="form.effDate"
                          :error-messages="errors.collect('form.effDate')"
                          v-validate="'required'"
                          readonly
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.minGstAdjust"
                          :label="labels.minGstAdjust"
                          :error-messages="errors.collect('form.minGstAdjust')"
                          data-vv-name="form.minGstAdjust"
                          :data-vv-as="labels.minGstAdjust"
                          v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.pctRcptAmt"
                          :label="labels.pctRcptAmt"
                          :error-messages="errors.collect('form.pctRcptAmt')"
                          data-vv-name="form.pctRcptAmt"
                          :data-vv-as="labels.pctRcptAmt"
                          v-validate="'mask_max_value:100.01|mask_min_value:0'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <cal-picker
                          v-model="form.lastDateOldGstRate"
                          :label="labels.lastDateOldGstRate"
                          :data-vv-as="labels.lastDateOldGstRate"
                          data-vv-name="form.lastDateOldGstRate"
                          :error-messages="errors.collect('form.lastDateOldGstRate')"
                          v-validate="'required'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs12 md6>
                        <cal-picker
                          v-model="form.lastDateRcvPayt"
                          :label="labels.lastDateRcvPayt"
                          :data-vv-as="labels.lastDateRcvPayt"
                          data-vv-name="form.lastDateRcvPayt"
                          :error-messages="errors.collect('form.lastDateRcvPayt')"
                          v-validate="'required'"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs12 md6>
                        <cal-picker
                          v-model="form.tranDatePatchRec"
                          :label="labels.tranDatePatchRec"
                          :data-vv-as="labels.tranDatePatchRec"
                          data-vv-name="form.tranDatePatchRec"
                          :error-messages="errors.collect('form.tranDatePatchRec')"
                          v-validate="tranDatePatchRecValidate()"
                          @change="doValTranDate()"
                          :loading="dateLoading"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="labels.tranSeq"
                          :items="tranSeqList"
                          item-text="label"
                          item-value="value"
                          v-model="form.tranSeq"
                          data-vv-name="form.tranSeq"
                          :data-vv-as="labels.tranSeq"
                          :error-messages="errors.collect('form.tranSeq')"
                          v-validate="'required'"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-expansion-panels class="mt-3" v-model="expanel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon>Filters</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-layout row wrap>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.acctNoFrom"
                              :label="labels.acctNoFrom"
                              :error-messages="errors.collect('form.acctNoFrom')"
                              data-vv-name="form.acctNoFrom"
                              :data-vv-as="labels.acctNoFrom"
                              :disabled="disableAcctNo"
                              v-validate="acctNoFromValidate()"
                              readonly
                              clearable
                              ><v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="doHelpList('acctNoFrom')">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.acctNoTo"
                              :label="labels.acctNoTo"
                              :error-messages="errors.collect('form.acctNoTo')"
                              data-vv-name="form.acctNoTo"
                              :data-vv-as="labels.acctNoTo"
                              :disabled="disableAcctNo"
                              v-validate="acctNoToValidate()"
                              readonly
                              clearable
                              ><v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="doHelpList('acctNoTo')">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.branch"
                              :label="labels.branch"
                              :error-messages="errors.collect('form.branch')"
                              data-vv-name="form.branch"
                              :data-vv-as="labels.branch"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="doHelpList('branch')">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md2>
                            <v-text-field
                              v-model="form.dept"
                              :label="labels.dept"
                              :error-messages="errors.collect('form.dept')"
                              data-vv-name="form.dept"
                              :data-vv-as="labels.dept"
                              :disabled="disableDept"
                              :loading="deptLoading"
                              @change="doValDept()"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="doHelpList('dept')">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              v-model="form.acctNo"
                              :label="labels.acctNo"
                              :error-messages="errors.collect('form.acctNo')"
                              data-vv-name="form.acctNo"
                              :data-vv-as="labels.acctNo"
                              :disabled="disableDept"
                              :loading="acctNoLoading"
                              @change="doValAcctNo()"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="doHelpList('acctNo')">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-autocomplete
                              :label="labels.tranType"
                              :items="tranTypeList"
                              item-text="label"
                              item-value="value"
                              v-model="form.tranType"
                              data-vv-name="form.tranType"
                              :data-vv-as="labels.tranType"
                              :error-messages="errors.collect('form.tranType')"
                              v-validate="'required'"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.tranType2RevOldRate"
                              :label="labels.tranType2RevOldRate"
                              :error-messages="errors.collect('form.tranType2RevOldRate')"
                              data-vv-name="form.tranType2RevOldRate"
                              :data-vv-as="labels.tranType2RevOldRate"
                              v-validate="tranType2RevOldRateValidate()"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.tranType2RebNewRate"
                              :label="labels.tranType2RebNewRate"
                              :error-messages="errors.collect('form.tranType2RebNewRate')"
                              data-vv-name="form.tranType2RebNewRate"
                              :data-vv-as="labels.tranType2RebNewRate"
                              v-validate="tranType2RebNewRateValidate()"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-spacer class="mt-3"></v-spacer>
                  <v-expansion-panels class="mt-3" v-model="expanel2" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon>Options</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-checkbox color="primary" :label="labels.tranCommOsBal" v-model="form.tranCommOsBal"></v-checkbox>
                          </v-flex>
                          <v-flex xs12>
                            <v-checkbox color="primary" :label="labels.patchRec" v-model="form.patchRec"></v-checkbox>
                          </v-flex>
                          <!-- <v-flex xs12>
                            <v-checkbox
                              color="primary"
                              :label="labels.endtNewGstRate"
                              v-model="form.endtNewGstRate"
                              :disabled="disableEndtNewGstRate"
                            ></v-checkbox>
                          </v-flex> -->
                          <v-flex xs12>
                            <v-checkbox color="primary" :label="labels.prtParams" v-model="form.prtParams"></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                <v-btn class="mt-3 mr-2" :loading="submitting" color="error" dark @click.prevent="doCancel"
                  >{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn
                >
                <v-btn class="mt-3 mr-2" :loading="submitting" color="info" @click.prevent="doReset">{{ labels.reset }}<v-icon dark right>mdi-refresh</v-icon></v-btn>
                <v-btn class="mt-3" :loading="submitting" color="primary" dark @click="doSubmit">
                  {{ labels.schedule }}
                  <v-icon right dark>mdi-clock</v-icon>
                </v-btn>
        </v-layout>
      </v-container>
    </div>

    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssign('branch', $event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="showGstRateHelpList" width="900px" persistent>
      <gst-rate-help-list
        v-if="showGstRateHelpList"
        :effDate="gstRateFilters.effDate"
        :gstType="gstRateFilters.gstType"
        :gstStat="gstRateFilters.gstStat"
        @close="showGstRateHelpList = false"
        @assign-gstRate-info="doAssign('gstRate', $event)"
      ></gst-rate-help-list>
    </v-dialog>

    <v-dialog v-model="showInterHelpList" width="900px" persistent>
      <intermediary-help-list
        :interGrps="'10,11,20,25'"
        @close="showInterHelpList = false"
        @assign-intermediary="doAssign('inter', $event)"
      ></intermediary-help-list>
    </v-dialog>

    <v-dialog v-model="showDeptHelpList" width="1080px">
      <dept-help-list @close="showDeptHelpList = false" @assign-dept="doAssign('dept', $event)"></dept-help-list>
    </v-dialog>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
      <batch-job-scheduler
        v-if="promptExeJob"
        :skipValidate="batchForm.skipValidate"
        :jobKeys="form"
        :showJobMode="false"
        @close="promptExeJob = false"
        @doPopulate="processBatch($event)"
      />
    </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import GstRateHelpList from '@/components/core/common/dialog/GstRateHelpList'
import DeptHelpList from '@/components/core/common/dialog/DeptHelpList'
import { formatPrice } from '@/utils/index'
import { expandURI } from '@/utils/ajax'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      labels: {
        oldGstRate: 'Old GST Status / Rate',
        newGstRate: 'New GST Status / Rate',
        effDate: 'Effective Date',
        minGstAdjust: 'Minimum GST Adjustment to Rebill',
        pctRcptAmt: '% of Receipt Amount matched off as late',
        lastDateOldGstRate: 'Last Date on which old GST Rate applies',
        lastDateRcvPayt: 'Last Date to receive payments at old rate',
        tranDatePatchRec: 'Transaction Date for Patched Records',
        tranSeq: 'Transaction Sequence',
        acctNoFrom: 'From Account No.',
        acctNoTo: 'To Account No.',
        tranDate: 'Set Transaction Date for Exchange Differences',
        branch: 'Branch',
        deptAcctNo: 'Department / Account No.',
        dept: 'Department',
        acctNo: 'Account No.',
        tranType: 'Transaction Type to be Rebilled',
        tranType2RevOldRate: 'Transaction Type 2 for Reversal of old rate',
        tranType2RebNewRate: 'Transaction Type 2 for Rebilling of new rate',
        tranCommOsBal: 'Process Transactions with Commission OS Balance',
        patchRec: 'Patch Records NOW',
        endtNewGstRate: 'Create Endorsements to capture new GST rate',
        prtParams: 'Print Parameters',
        cancel: 'Cancel',
        schedule: 'Schedule',
        reset: 'Reset'
      },
      form: {
        oldGstRate: '',
        newGstRate: '',
        effDate: null,
        minGstAdjust: 0,
        pctRcptAmt: 100,
        lastDateOldGstRate: null,
        lastDateRcvPayt: null,
        tranDatePatchRec: new Date(),
        tranSeq: 'A',
        acctNoFrom: '',
        acctNoTo: '',
        branch: 'All',
        deptAcctNo: '',
        dept: '',
        acctNo: '',
        tranType: 'All',
        tranType2RevOldRate: 'A',
        tranType2RebNewRate: 'B',
        tranCommOsBal: false,
        patchRec: false,
        endtNewGstRate: false,
        prtParams: false
      },
      tranSeqList: [
        { label: 'Account No.', value: 'A' },
        { label: 'Department', value: 'D' }
      ],
      tranTypeList: [
        { label: 'All', value: 'All' },
        { label: 'M - Direct Business Debit Note', value: 'M' },
        { label: 'O - Reinsurance Inward Debit Note', value: 'O' },
        { label: 'R - Direct Business Credit Note', value: 'R' },
        { label: 'T - Reinsurance Inward Credit Note', value: 'T' }
      ],
      scheduleForm: {
        jobName: 'qrtzGstRebilling',
        jobDesc: 'GST Re-billing'
      },
      loading: false,
      dateLoading: false,
      acctNoLoading: false,
      deptLoading: false,
      submitting: false,
      showBranchHelpList: false,
      showCurrencyHelpList: false,
      showGstRateHelpList: false,
      showInterHelpList: false,
      showDeptHelpList: false,
      scheduleJobModal: false,
      gstRateFilters: {
        effDate: new Date(),
        gstStat: '',
        gstType: ''
      },
      expanel: [0],
      expanel1: [0],
      expanel2: [],
      disableAcctNo: false,
      disableDept: true,
      disableEndtNewGstRate: true,
      acctNoType: ''
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      if (this.$store.state.accounts.init === 0) {
        await Promise.all([this.$store.dispatch('accountsInit')])
      }
      await Promise.all([this.$store.dispatch('gstRebillingInit')])
      this.loading = false
    },
    async doValTranDate() {
      if (this.form.tranDatePatchRec !== null || this.form.tranDatePatchRec !== '') {
        const apiURI = this.menu.validateTranDate
        if (apiURI) {
          this.dateLoading = true
          try {
            const expand = {
              tranDate: this.form.tranDatePatchRec
            }
            await this.$http.get(expandURI(apiURI, expand))
            this.resetMessage('form.tranDatePatchRec')
            this.dateLoading = false
          } catch (err) {
            this.dateLoading = false
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          }
        }
      }
    },
    async doValDept() {
      if (this.form.dept != null || this.form.dept !== '') {
        const apiURI = this.menu.validateDept
        if (apiURI) {
          this.deptLoading = true
          try {
            const expand = {
              dept: this.form.dept
            }
            await this.$http.get(expandURI(apiURI, expand))
            this.resetMessage('form.dept')
            this.deptLoading = false
          } catch (err) {
            this.deptLoading = false
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          }
        }
      }
    },
    async doValAcctNo() {
      if (this.form.acctNo !== null || this.form.acctNo !== '') {
        const apiURI = this.menu.validateInter
        if (apiURI) {
          this.acctNoLoading = true
          try {
            const expand = {
              acctNo: this.form.acctNo,
              tranDate: this.form.tranDatePatchRec
            }
            await this.$http.get(expandURI(apiURI, expand))
            this.resetMessage('form.acctNo')
            this.acctNoLoading = false
          } catch (err) {
            this.acctNoLoading = false
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          }
        }
      }
    },
    doHelpList(fieldName) {
      switch (fieldName) {
        case 'oldGstRate':
          this.gstRateFilters.gstType = fieldName
          this.gstRateFilters.effDate = new Date()
          this.gstRateFilters.gstStat = ''
          this.showGstRateHelpList = true
          break
        case 'newGstRate':
          this.gstRateFilters.gstType = fieldName
          this.showGstRateHelpList = true
          break
        case 'acctNoFrom':
        case 'acctNoTo':
        case 'acctNo':
          this.showInterHelpList = true
          this.acctNoType = fieldName
          break
        case 'branch':
          this.showBranchHelpList = true
          break
        case 'dept':
          this.showDeptHelpList = true
          break
      }
    },
    doReset() {
      this.form.oldGstRate = ''
      this.form.newGstRate = ''
      this.form.effDate = null
      this.form.minGstAdjust = 0
      this.form.pctRcptAmt = 100
      this.form.lastDateOldGstRate = null
      this.form.lastDateRcvPayt = null
      this.form.tranDatePatchRec = new Date()
      this.form.tranSeq = 'A'
      this.form.acctNoFrom = ''
      this.form.acctNoTo = ''
      this.form.branch = 'All'
      this.form.deptAcctNo = ''
      this.form.dept = ''
      this.form.acctNo = ''
      this.form.tranType = 'All'
      this.form.tranType2RevOldRate = 'A'
      this.form.tranType2RebNewRate = 'B'
      this.form.tranCommOsBal = false
      this.form.patchRec = false
      this.form.endtNewGstRate = false
      this.form.prtParams = false
    },
    doCancel() {
      this.$router.push({ name: 'specFuncAcct' }).catch(() => {})
    },
    doSubmit() {
      this.promptResubmit = false
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.isBatchManager === true) {
            this.promptExeJob = true
          } else {
            this.doSchedule()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSchedule() {
      const apiURI = this.menu.doSchedule
      if (apiURI) {
        try {
          this.submitting = true
          const result = this.$http.post(apiURI, this.form)
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processBatch(bmgForms) {
      const apiURI = this.menu.exeBatch
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, bmgForms)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
      this.batchForm.skipValidate = false
    },
    doAssign(fieldName, obj) {
      switch (fieldName) {
        case 'branch':
          this.form.branch = obj.finalSelectedItems.toString()
          this.showBranchHelpList = false
          break
        case 'gstRate':
          if (this.gstRateFilters.gstType === 'oldGstRate') {
            this.form.oldGstRate = obj.gstStat + ' / ' + formatPrice(obj.gstRate)
            this.gstRateFilters.effDate = new Date(obj.effDate)
            this.gstRateFilters.gstStat = obj.gstStat
            this.form.newGstRate = ''
          } else {
            this.form.newGstRate = obj.gstStat + ' / ' + formatPrice(obj.gstRate)
            this.form.effDate = new Date(obj.effDate)
            var d = new Date(obj.effDate)
            d.setDate(d.getDate() - 1)
            this.form.lastDateOldGstRate = d
          }
          this.showCurrencyHelpList = false
          break
        case 'inter':
          if (this.acctNoType === 'acctNoFrom') {
            this.form.acctNoFrom = obj
          } else if (this.acctNoType === 'acctNoTo') {
            this.form.acctNoTo = obj
          } else {
            this.form.acctNo = obj
            this.doValAcctNo()
          }
          break
        case 'dept':
          this.form.dept = obj
          this.doValDept()
          break
      }
    },
    formatPrice(data) {
      return formatPrice(data)
    },
    acctNoFromValidate() {
      if ((this.form.acctNoFrom === null && this.form.acctNoTo !== null) || (this.form.acctNoFrom === '' && this.form.acctNoTo !== '')) {
        return 'required'
      } else {
        return 'acctNoRangeFrom:' + this.form.acctNoTo
      }
    },
    acctNoToValidate() {
      if ((this.form.acctNoFrom !== null && this.form.acctNoTo === null) || (this.form.acctNoFrom !== '' && this.form.acctNoTo === '')) {
        return 'required'
      } else {
        return 'acctNoRangeTo:' + this.form.acctNoFrom
      }
    },
    tranType2RevOldRateValidate() {
      if (this.form.tranType2RevOldRate === null || this.form.tranType2RevOldRate === '') {
        return 'required'
      } else {
        return 'tranType2RevOldRate|tranType2RevOldRate2:' + this.form.tranType2RebNewRate
      }
    },
    tranType2RebNewRateValidate() {
      if (this.form.tranType2RebNewRate === null || this.form.tranType2RebNewRate === '') {
        return 'required'
      } else {
        return 'tranType2RebNewRate|tranType2RebNewRate2:' + this.form.tranType2RevOldRate
      }
    },
    tranDatePatchRecValidate() {
      if (this.form.tranDatePatchRec === '' || this.form.tranDatePatchRec === null) {
        return 'required'
      } else {
        if (this.form.lastDateOldGstRate !== '' && this.form.lastDateOldGstRate !== null) {
          return 'valTranDatePatchRec:' + this.form.lastDateOldGstRate + '|valTranDatePatchRec2:' + this.form.lastDateRcvPayt
        }
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('valTranDatePatchRec', {
      getMessage(field, args) {
        return field + ' must be greater than Last Date on which old GST Rate applies'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var lastDateOldGstRate = args[0]
        if (lastDateOldGstRate) {
          return !isAfter(removeTime(lastDateOldGstRate), removeTime(value))
        }
      }
    })

    this.$validator.extend('valTranDatePatchRec2', {
      getMessage(field, args) {
        return field + ' must be greater than Last Date to receive payments at old rate'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var lastDateRcvPayt = args[0]
        if (lastDateRcvPayt) {
          return !isAfter(removeTime(lastDateRcvPayt), removeTime(value))
        }
      }
    })

    this.$validator.extend('tranType2RevOldRate', {
      getMessage: (field, args) => {
        return field + ' cannot be C, E, N, R or T'
      },
      validate: (value, args) => {
        let v = value.toLowerCase()
        if (v && (v === 'c' || v === 'e' || v === 'n' || v === 'r' || v === 't')) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('tranType2RevOldRate2', {
      getMessage: (field, args) => {
        return field + ' cannot be the same as screen value of Transaction Type 2 for Rebilling of new rate'
      },
      validate: (value, args) => {
        let v = value.toLowerCase()
        let y = args[0].toLowerCase()
        if (v && v === y) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('tranType2RebNewRate', {
      getMessage: (field, args) => {
        return field + ' cannot be C, E, N, R or T'
      },
      validate: (value, args) => {
        let v = value.toLowerCase()
        if (v && (v === 'c' || v === 'e' || v === 'n' || v === 'r' || v === 't')) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('tranType2RebNewRate2', {
      getMessage: (field, args) => {
        return field + ' cannot be the same as screen value of Transaction Type 2 for Reversal of old rate'
      },
      validate: (value, args) => {
        let v = value.toLowerCase()
        let y = args[0].toLowerCase()
        if (v && v === y) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctNoRangeFrom', {
      getMessage: (field, args) => {
        return field + ' must less than or equal To Account No.'
      },
      validate: (value, args) => {
        if (value > args) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctNoRangeTo', {
      getMessage: (field, args) => {
        return field + ' must greater than or equal From Account No.'
      },
      validate: (value, args) => {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.specFuncAcct.gstRebilling.menu
    }
  },
  watch: {
    'form.tranSeq': function(value) {
      if (value === 'A') {
        this.disableAcctNo = false
        this.disableDept = true
        this.form.deptAcctNo = ''
        this.form.dept = ''
        this.form.acctNo = ''
      } else {
        this.disableAcctNo = true
        this.disableDept = false
        this.form.acctNoFrom = ''
        this.form.acctNoTo = ''
      }
    },
    'form.patchRec': function(value) {
      if (value) {
        this.disableEndtNewGstRate = false
      } else {
        this.disableEndtNewGstRate = true
        this.form.endtNewGstRate = false
      }
    }
  },
  mixins: [MessageMixin, commonAjaxMixin, commonMixins, accountsAjaxCalls, batchManagerMixin],
  components: {
    MultiBranchHelpList,
    GstRateHelpList,
    IntermediaryHelpList,
    DeptHelpList,
    BatchJobScheduler
  }
}
</script>
<style lang="scss"></style>
